import { useEffect, useRef, useState } from "react";
import { LocationService } from "shared/services";
import MultiListPage from "./MultiListPagination";
import LocationCard from "./LocationCard";
import { HeartPlusIcon } from "shared/assets/icons";
import { Col, Row } from "react-bootstrap";
import store from "features/store";
import { new_image_thumbnail } from "shared/images/images";
import { convertToMaintainData } from "shared/settings/stateMaintain";
import { Loader } from "shared/hoc/loader/Loader";
import { Pagination } from "./Pagination";
import { useDispatch, useSelector } from "react-redux";
import '../Locations/LocationsList.scss';
import { isAuthorized } from "shared/settings/auth";

const initialPayload = {
    "field": ["id", "title", "contactname", "email", "salecount", "phone", "imageurl", "locationstatecode", "locationcode", "website", "state", "city"],
    "filter": [],
    "sort": [{ "field": "title", "direction": "asc" }],
    "page": {}
}

export const LocationListHoc = ({ props, search }) => {

    const dispatch = useDispatch();
    const statemaintenance = useSelector(state => state?.statemaintenance);
    const currentindex = useRef(1)
    const totalrecord = useRef(0)
    const addedfav = useRef(false)

    const user = useSelector(state => state.user);

    const [pageLoading, setPageLoading] = useState(true);
    const [favLocIds, setFavLocIds] = useState([]);
    const [favoriteLocationData, setFavoriteLocationData] = useState({});
    const [moreLocationData, setMoreLocationData] = useState({});

    useEffect(() => {
        getApiData();
    }, [search, user.id]);

    const getApiData = async () => {
        if( statemaintenance?.["Location-List"] ) {
            let data = statemaintenance?.["Location-List"]
            totalrecord.current = data?.total
            onPageChangeCallback(data?.["pagekey"], data?.currentPage)
        } else {
            onPageChangeCallback();
        }
        // try {
        //     setPageLoading(true);
        //     let favLocIds = [];
        //     const postData = {
        //         field: ["id", "locationid", "buyerid"],
        //         filter: [],
        //         sort: [{ field: "id", direction: "asc" }],
        //         page: { size: 999 }
        //     };

        //     if ( user.id ) {
        //         const favLocationResponse = await LocationService.getFavoriteLocation(postData);
                
        //         favLocIds = favLocationResponse.data.data.map(x => x.locationid);

        //         const favPayload = formFavPayload(favLocIds);
        //         const favLocationDataResponse = await getFavLocationLists(favLocIds, favPayload);
        //         setFavoriteLocationData(favLocationDataResponse);

        //         favLocIds = favLocationDataResponse.data.map(x => x.id);

        //         setFavLocIds(favLocIds);
        //     }

        //     const nonFavPayload = formNonFavPayload(favLocIds);
        //     const moreLocationDataResponse = await getMoreLocationLists(nonFavPayload);
        //     setMoreLocationData(moreLocationDataResponse);

        //     setPageLoading(false);
        // } catch (error) {
        //     setPageLoading(false);
        // }
    };

    const formFavPayload = (locationIds) => {
        let favPayload = JSON.parse(JSON.stringify(initialPayload));

        if (locationIds.length > 0) {
            favPayload.filter.push({ "field": "id", "value": [locationIds], "op": "IN", "join": "AND" });
        }

        if (search) {

            if (search.filter) {
                favPayload.filter = [...favPayload.filter, ...search.filter];
            }

            if (search.sort) {
                favPayload.sort = search.sort;
            }
        }

        favPayload.page = { size: locationIds.length };

        return favPayload;
    };

    const formNonFavPayload = (locationIds) => {
        let nonFavPayload = JSON.parse(JSON.stringify(initialPayload));
        let constPageSize = 24;

        if (locationIds.length > 0) {
            nonFavPayload.filter.push({ "field": "id", "value": [locationIds], "op": "NOT IN", "join": "AND" });
        }

        if (search) {

            if (search.filter) {
                nonFavPayload.filter = [...nonFavPayload.filter, ...search.filter];
            }

            if (search.sort) {
                nonFavPayload.sort = search.sort;
            }
        }

        nonFavPayload.page = { size: 24 };

        return nonFavPayload;
    }

    const getFavLocationLists = (locationids, payload) => {

        return new Promise((resolve, reject) => {
            if (locationids.length > 0) {
                LocationService.getLocationList(payload).then(response => {
                    resolve(response.data);
                }).catch((error) => {
                    reject(error);
                });
            } else {
                resolve({ data: [] });
            }
        });
    }

    const getMoreLocationLists = (payload) => {
        return new Promise((resolve, reject) => {
            LocationService.getLocationList(payload).then(response => {
                resolve(response.data);
            }).catch((error) => {
                reject(error);
            });
        })
    }

    const onPageChangeCallback = async(page=null, currentPageNumber=1, previousPageNumber=0,total=totalrecord.current) => {
        setPageLoading(true)
        let favLocId = favLocIds
        let pageSize = 24
        if (currentPageNumber == 1 || addedfav.current) {
            if (user.id && isAuthorized()) {
                const postData = {
                    field: ["id", "locationid", "buyerid"],
                    filter: [],
                    sort: [{ field: "id", direction: "asc" }],
                    page: { size: 999 }
                };
                const favLocationResponse = await LocationService.getFavoriteLocation(postData);
                favLocId = favLocationResponse.data.data.map(x => x.locationid);
                // pageSize = pageSize - favLocationResponse?.data?.data?.length || 0
                setFavLocIds(favLocId)
                const favPayload = formFavPayload(favLocId);
                const favLocationDataResponse = await getFavLocationLists(favLocId, favPayload);
                setFavoriteLocationData(favLocationDataResponse);
            }
        } else {
            setFavoriteLocationData([])
            
        }

        const nonFavPayload = formNonFavPayload(favLocId);
        page = { ...page, size: pageSize }
        nonFavPayload.page = { ...nonFavPayload.page, ...page };
        addedfav.current =false
        getMoreLocationLists(nonFavPayload).then(response => {
            setMoreLocationData(response);
            setPageLoading(false);
            const scrollContainer = document.querySelector('.scroll-content');
            if (scrollContainer) {
                if(statemaintenance?.["Location-List"]?.scrollindex) {
                    scrollContainer.scrollTop =  statemaintenance?.["Location-List"]?.scrollindex

                    let pusttoStore = { ...statemaintenance };
                    pusttoStore["Location-List"] = {
                        ...pusttoStore?.["Location-List"],
                        scrollindex: null
                    }
                    dispatch({
                        type: 'PUSH_TO_STATE', payload: pusttoStore
                    });
                    
                    // scrollContainer.scrollTo({ top: statemaintenance?.["Location-List"]?.scrollindex, left: 0, behavior: 'smooth' });
                } else {
                    scrollContainer.scrollTop = 0;
                }
            } else {
                window.scrollTo(0, 0);
            }
            currentindex.current = currentPageNumber
            let pusttoStore = { ...statemaintenance }
            pusttoStore["Location-List"] = {
                ...pusttoStore?.["Location-List"],
                pagekey: page,
                currentPage: currentPageNumber,
                previousPage:previousPageNumber,
                total: total || totalrecord.current,
                scrollindex:0
            }
            dispatch({
                type: 'PUSH_TO_STATE', payload: pusttoStore
            });
    
        }).catch(error => {
            setPageLoading(false);
        });
    };

    const isFavoriteLocation = (location) => {
        return favLocIds.includes(location.id);
    }

    const favoriteLocation = (location) => {
        if (user.id) {
            if (isFavoriteLocation(location)) {
                removeFavoriteLocation(location);
            } else {
                addFavoriteLocation(location);
            }
        } else {
            signIn();
        }
    };

    const addFavoriteLocation = (location) => {
        const postData = { data: { locationid: location.id } };

        LocationService.addFavoriteLocation(postData).then(res => {
            addedfav.current =true
            getApiData();
        }).catch(() => {
        });
    };

    const removeFavoriteLocation = (location) => {
        const postData = { data: { locationIds: [{ id: location.id }] } };

        LocationService.deleteFavoriteLocation(postData).then(() => {
            addedfav.current =true
            getApiData();
        }).catch(() => {
        });
    };

    const getProfileImage = (location) => {
        const locationImage = {};
        if (location.imageurl) {
            const image = location.imageurl.split(',');
            image.forEach(x => {
                const temp = x.split('#*#');
                locationImage[temp[0]] = temp[1];
            });
        }
        return locationImage.profile ? locationImage.profile : new_image_thumbnail;
    }

    const navigate = (event, location) => {
        const scrollContainer = document.querySelector('.scroll-content');
            let pusttoStore = { ...statemaintenance }
            delete pusttoStore["Estate-Sale-List"]
            delete pusttoStore["EstateItemList"]
            pusttoStore["Location-List"] = {
                ...pusttoStore?.["Location-List"],
                scrollindex:scrollContainer.scrollTop
            }
            dispatch({
                type: 'PUSH_TO_STATE', payload: pusttoStore
            });
        
        const data = {
            favoriteLocationData,
            moreLocationData
        };

        convertToMaintainData(moreLocationData, data);

        const url = location.locationcode
            ? `/estate-sales/${location.locationstatecode}/${location.locationcode}`
            : `/estate-sales/${location.locationstatecode}`;

        props.history.push(url);
    };

    const signIn = () => {
        store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: 'Sign-In' } });
    }

    return (
        <div className="location-list-container">
            {
                pageLoading ? 
                <Loader /> :
                <>
                    {<div className={`list-section ${favLocIds.length === 0 ? 'h-75' : ''} ${currentindex.current !== 1 ?'dispayhide':''}`}>
                        <div className={`d-flex flex-column align-items-center justify-content-center ${favLocIds.length === 0 ? 'h-75' : ''}`}>
                            <div className="loc-large-screen-width">
                                <div className='d-flex mt-5 flex-column'>
                                    <div className='d-flex align-items-center gap-3'>
                                        <img className="img-resp" src={`${process.env.PUBLIC_URL}/static/images/heart-bold.svg`} alt="heart-icon" style={{ width: "25px" }}></img>
                                        <div className='font-weight-bold text-inactive head-resp' style={{ color: "#00263E", fontSize: "24px" }}>Your Favorite Locations</div>
                                    </div>
                                    <div className='mb-5 mt-3'>
                                        {user.id && Array.isArray(favoriteLocationData.data) && favoriteLocationData.data.length > 0 ?
                                            <div>
                                                <Row xs={1} sm={1} md={2} lg={3} className="mt-3">
                                                    {
                                                        window.innerWidth <= 768 ?
                                                            <MultiListPage
                                                                list={favoriteLocationData.data}
                                                                renderItem={(location, index) => {
                                                                    return (
                                                                        <div className="p-2" >
                                                                            <LocationCard
                                                                                locationData={location}
                                                                                isFav={isFavoriteLocation(location)}
                                                                                addFav={() => { favoriteLocation(location) }}
                                                                                getProfileImage={getProfileImage(location)}
                                                                                navigate={(event) => { navigate(event, location) }}
                                                                            />
                                                                        </div>
                                                                    )
                                                                }}
                                                                count={favoriteLocationData.data.length}
                                                                screensize={2}
                                                            />
                                                            :
                                                            favoriteLocationData.data.map((location, index) =>
                                                                <Col key={`location_${index}`}>
                                                                    <LocationCard
                                                                        locationData={location}
                                                                        isFav={isFavoriteLocation(location)}
                                                                        addFav={() => { favoriteLocation(location) }}
                                                                        getProfileImage={getProfileImage(location)}
                                                                        navigate={(event) => { navigate(event, location) }}
                                                                    />
                                                                </Col>
                                                            )
                                                    }
                                                </Row>
                                            </div>
                                            :
                                            !user.id ? <div className='text-center clickable txt-navy' onClick={() => { store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: 'Sign-In' } }); }} style={{ fontSize: "18px" }}>
                                                Please login to view favorite locations <span className='heart-img'>{HeartPlusIcon}</span></div> :
                                                <div className='text-center clickable txt-navy' style={{ fontSize: "18px" }}>You don’t have any Favorite locations yet. Click on the “heart” buttons to save a location <span className='heart-img'>{HeartPlusIcon}</span></div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}

                    <div className={`list-section ${moreLocationData.length === 0 ? 'h-75' : ''}`} style={{ backgroundColor: "#FFFFFF" }}>
                        <div className={`d-flex flex-column align-items-center justify-content-center ${moreLocationData.length === 0 ? 'h-75' : ''}`}>
                            <div className="loc-large-screen-width">
                                <div className='mt-5 text-inactive font-weight-bold head-resp' style={{ color: "#00263E", fontSize: "24px", lineHeight: '32px' }}>More Locations</div>
                                {
                                    Array.isArray(moreLocationData.data) && moreLocationData.data.length > 0 ?
                                        <Row xs={1} sm={1} md={2} lg={3} className="mt-3">
                                            {
                                                moreLocationData.data.map((location, index) =>
                                                    <Col key={`location_${index}`}>
                                                        <LocationCard
                                                            locationData={location}
                                                            isFav={isFavoriteLocation(location)}
                                                            addFav={() => { favoriteLocation(location) }}
                                                            getProfileImage={getProfileImage(location)}
                                                            navigate={(event) => { navigate(event, location) }}
                                                        />
                                                    </Col>
                                                )
                                            }
                                        </Row> : <div className="d-flex flex-column mb-3">
                                            <div className="text-center no-data-search-icon">
                                                <i className="fas fa-search fa-3x"></i>
                                            </div>
                                            <div className="text-center h4 text-bold">
                                                No results found
                                            </div>
                                            <div className="text-center text-muted h5">
                                                We couldn't find what you're looking for.
                                            </div>
                                        </div>
                                }
                            </div>
                        </div>
                    </div> 
                </>
            }

            <div style={{ backgroundColor: "#FFFFFF" }}>
                <Pagination loading={pageLoading} page={moreLocationData.page} 
                    onPageChangeCallback={(page, currentPageNumber, previousPageNumber,total) => {onPageChangeCallback(page, currentPageNumber, previousPageNumber,total)}}
                    pageData={{
                        currentindex:currentindex.current,
                        total:totalrecord?.current
                    }}  />
            </div>
        </div>
    )
}